import dayjs from 'dayjs';

export default {
  filesFormatter(arr) {
    if (!arr || !arr.length) return [];
    return arr.map((item) => ({
      name: item.name,
      publicUrl: item.publicUrl || '',
    }));
  },
  imageFormatter(arr) {
    if (!arr || !arr.length) return [];
    return arr.map((item) => ({
      publicUrl: item.publicUrl || '',
    }));
  },
  oneImageFormatter(arr) {
    if (!arr || !arr.length) return '';
    return arr[0].publicUrl || '';
  },
  dateFormatter(date) {
    if (!date) return '';
    return dayjs(date).format('YYYY-MM-DD');
  },
  dateTimeFormatter(date) {
    if (!date) return '';
    return dayjs(date).format('YYYY-MM-DD HH:mm');
  },
  booleanFormatter(val) {
    return val ? 'Yes' : 'No';
  },
  dateFormatterTH(date,type){
    date = new Date(date)
    let options = {}

    switch(type) {
      case 1:
        //20 ก.ย. 2565 14:40
        options = {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          // weekday: 'long',//วันอังคารที่
          timeZone: "Asia/Bangkok",
          hour: '2-digit', minute:'2-digit'
        }
        break;
      case 2:
        //วันอังคารที่ 20 ก.ย. 2565 14:40
        options = {
          year: 'numeric',
          month: 'short',//long
          day: 'numeric',
           weekday: 'long',//วันอังคารที่
          timeZone: "Asia/Bangkok",
          hour: '2-digit', minute:'2-digit'
        }
        break;
      case 3:
        //20 ก.ย. 2565
        options = {
          year: 'numeric',
          month: 'short', //long
          day: 'numeric',
          // weekday: 'long',//วันอังคารที่
          timeZone: "Asia/Bangkok",

        }
        break;
      case 4:
        //ก.ย. 2565
        options = {
          year: 'numeric',
          month: 'short', //long
          // weekday: 'long',//วันอังคารที่
          timeZone: "Asia/Bangkok",

        }
        break;
      default:
        //วันอังคารที่ 20 กันยายน 2565 14:40
        options = {
          year: 'numeric',
          month: 'long',//short
          day: 'numeric',
          weekday: 'long',//วันอังคารที่
          timeZone: "Asia/Bangkok",
          hour: '2-digit', minute:'2-digit'
        }
    }



    const result = date.toLocaleDateString('th-TH', options)
    return result;
  }
};
